import { ContentShare, useContentShareControls } from 'amazon-chime-sdk-component-library-react';
import classNames from 'classnames';
import React from 'react';
import { ScreenShare as ScreenShareIcon } from '../../../../icons';
import { useSession } from '../../../session-provider';
import { useVideoConfig } from '../../../video-config-provider';
import { Content } from '../content';
import ts from '../tile.scss';
import s from './screen-share.scss';
export const ScreenShare = () => {
    const { mobile, texts, dashboard } = useVideoConfig();
    const { currentAttendeeId, sharingAttendeeId } = useSession();
    const { toggleContentShare } = useContentShareControls();
    if (!sharingAttendeeId) {
        return null;
    }
    return (React.createElement(Content, { className: classNames(s.root, ts.tile, { [s.mobile]: mobile, [s.dashboardContainer]: dashboard }), attendeeId: sharingAttendeeId, hideIndicators: true },
        React.createElement(ContentShare, { className: classNames(s.root, ts.tile) }),
        currentAttendeeId === sharingAttendeeId && (React.createElement("div", { className: s.buttonContainer },
            React.createElement("div", { className: classNames(s.text, { [s.dashboardText]: dashboard }) }, texts.sharingScreen),
            React.createElement("button", { className: classNames(s.button, { [s.dashboardButton]: dashboard }), onClick: toggleContentShare },
                !dashboard && React.createElement(ScreenShareIcon, null),
                texts.stopSharing)))));
};
//# sourceMappingURL=screen-share.js.map